// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__DnDyN"};